module.exports = __webpack_public_path__ + "static/media/stab_ban.59f734c9.jpeg";